import { MacBookWindow } from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={<>Smart Contract Development Services with Rumble Fish</>}
        description={
          <>From complex business rules to elegant and secure smart contracts</>
        }
        buttonText="Let's talk!"
        buttonLink="/contact"
        buttonHandleOnClick={() => scrollToElement(contactFormId)}
        gradient="orange"
      />
    </>
  );
};
